<template>
  <div class="container">
    <div class="handle-box">
      <el-input v-model="query.name" placeholder="套餐名" class="handle-input mr10"></el-input>
      <el-select v-model="query.company_id" clearable class="mr10" placeholder="所属加盟商" size="large" style="width: 300px;">
        <el-option v-for="(item, index) in companyData" :key="index" :label="item.name" :value="item.id" />
      </el-select>
      <el-select v-model="query.min_hour" clearable class="mr10" placeholder="最小时长" size="large">
        <el-option v-for="(num, index) in 8" :key="index" :label="num" :value="num" />
      </el-select>
      <el-select v-model="query.max_hour" clearable class="mr10" placeholder="最大时长" size="large">
        <el-option v-for="(num, index) in 8" :key="index" :label="num" :value="num" />
      </el-select>
      <el-select v-model="query.is_validate" clearable placeholder="是否有效" class="handle-select mr10">
        <el-option key="1" label="有效" value="1"></el-option>
        <el-option key="2" label="无效" value="0"></el-option>
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加</el-button>
    </div>
    <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header">
      <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
      <el-table-column label="套餐名" width="300">
        <template #default="scope">
          <el-button :style="'color:#409EFF'" type="text" @click="showDetail(scope.row.id)">
            {{ scope.row.name }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="封面" prop="cover" align="center" width="100">
        <template #default="scope">
          <el-image class="table-td-thumb" :src="scope.row.cover" :preview-src-list="[scope.row.cover]"
            :hide-on-click-modal="true"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="所属加盟商" align="center" width="300">
        <template #default="scope">
          {{ companyMap.get(scope.row.company_id) }}
        </template>
      </el-table-column>
      <el-table-column label="成本(元)" align="right">
        <template #default="scope">
          {{ parseFloat(scope.row.cost / 100).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column label="价格(元)" align="right">
        <template #default="scope">
          {{ parseFloat(scope.row.price / 100).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="sales" label="销量" align="center"></el-table-column>
      <el-table-column prop="hour" label="时长" align="center"></el-table-column>

      <el-table-column label="是否有效" width="100" align="center">
        <template #default="scope">
          <el-button type="text" :style="'color:' + [!scope.row.is_validate ? 'red' : '']"
            @click="setIsvalidate(scope.$index, scope.row.id, !scope.row.is_validate)">
            {{ scope.row.is_validate ? "有效" : "无效" }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center">
        <template #default="scope">
          <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">编辑
          </el-button>
          <el-button type="text" icon="el-icon-delete" class="red" @click="handleDelete(scope.row.id)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination background layout="total, prev, pager, next" :current-page="query.page"
        :page-size="query.page_size" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
    </div>
      <!-- 编辑弹出框 -->
  <el-dialog :title="actTitle + '套餐'" v-model="editVisible" width="70%">
    <el-tabs v-model="activeTab" type="card" @tab-click="changeTab">
      <el-tab-pane name="info" label="基本信息">
        <el-form ref="form" :model="form" class="el-dialog__body" label-width="80px">
          <el-form-item label="套餐名" required>
            <el-input v-model="form.name" style="width: 90%"></el-input>
          </el-form-item>
          <el-form-item label="加盟商" prop="type">
            <el-select v-model="form.company_id" filterable placeholder="输入加盟商名可搜索">
              <el-option v-for="item in franchiseeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="封面">
            <el-upload class="avatar-uploader" :action="action" :show-file-list="false"
              :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <img v-if="form.cover" :src="form.cover" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <el-button type="text" @click="form.cover = ''" style="color: red">删除</el-button>
          </el-form-item>

          <el-form-item label="成本" required>
            <el-input-number v-model="form.cost" :precision="2" :min="0" :controls="false" :max="4294967295" />
            元
          </el-form-item>
          <el-form-item label="价格" required>
            <el-input-number v-model="form.price" :precision="2" :min="0" :controls="false" :max="4294967295" />
            元
          </el-form-item>
          <el-form-item label="时长" required>
            <el-input-number v-model="form.hour" :min="0" :controls="false" :max="255" />
            时
          </el-form-item>
          <el-form-item>
            <tinymce-text id="tinymce" @input="tinymcechange" @release="release" v-model:value="form.memo"
              class="tinymce"></tinymce-text>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane name="time" label="显示时间">
        <div class="demo-collapse">
          <el-collapse @change="handleChange" v-for="(item, index) in weekList" :key="index">
            <el-collapse-item :title="item.label" name="1">
              <div class="time_box">
                <div v-for="(time, time_index) in item.timeList" :key="time_index"
                  :class="time.is_select ? 'time_active' : 'time_item'" @click="changeAtive(index, time_index)">
                  {{ time.time1 }}
                </div>
              </div>
              <div class="btn_style">
                <el-button @click="handleAllSelect(index)">
                  全选
                </el-button>
                <el-button @click="cancelAllSelect(index)">
                  清空
                </el-button>
                <el-button @click="onReSet(index)">
                  重置
                </el-button>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-tab-pane>
    </el-tabs>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveEdit">确 定</el-button>
      </span>
    </template>
  </el-dialog>
  <!--详情弹出框-->
  <el-dialog title="套餐详情" v-model="detailVisible" width="55%">
    <div class="detail_style">
      <div><img :src="detailData.cover" alt="商品封面"></div>
      <div class="row_style">
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple fw900">套餐名称:</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ detailData.name }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple fw900">时长:</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ detailData.hour + ' h ' }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple fw900">成本:</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ detailData.cost / 100 + ' 元 ' }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple fw900">价格:</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ detailData.price / 100 + ' 元 ' }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple fw900">销量:</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ detailData.sales }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple fw900">是否有效：</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ detailData.is_validate ? "有效" : "无效" }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="6">
            <div class="grid-content bg-purple fw900">创建时间：</div>
          </el-col>
          <el-col :span="18">
            <div class="grid-content bg-purple">{{ ForMatHMS(detailData.c_at) }}</div>
          </el-col>
        </el-row>
      </div>
    </div>
  </el-dialog>
  </div>

</template>

<script>
import {
  getMealList,
  deleteMeal,
  saveMeal,
  getMealDetail,
  setMealIsvalidate,
} from "@/api/meal";
import { getCompanyList } from '@/api/company'
import moment from "moment";
import TinymceText from "@/components/TinymceText";
import { getFranchisee } from "@/api/store";

export default {
  name: "MealTable",
  components: {
    TinymceText,
  },
  data() {

    return {
      action: 'https://wx.yixiankeji.com/admin/upload',
      query: {
        name: "",
        min_hour: null,
        max_hour: null,
        is_validate: null,
        page: 1,
        page_size: 10
      },
      actTitle: "添加",
      form: {}, //提交表单数据
      tableData: [],
      pageTotal: 0,
      editVisible: false,
      detailVisible: false,
      detailData: {},
      franchiseeOptions: [],
      timeList: [],
      weekList: [
        { value: 1, label: '周一' },
        { value: 2, label: '周二' },
        { value: 3, label: '周三' },
        { value: 4, label: '周四' },
        { value: 5, label: '周五' },
        { value: 6, label: '周六' },
        { value: 7, label: '周日' },
      ],
      openTime: '',
      activeTab: 'info',
      timeObj: {},
      companyMap:new Map(),
      companyData:[]
    };
  },
  created() {
    this.init()
  },
  computed: {

  },
  methods: {
    init() {
      this.getData();
      this.getCompanyMap()
    },
    ForMatHMS(date) {
      return moment(parseInt(date + "000")).format("YYYY-MM-DD HH:mm:ss")
    },
    dateFormat: function (row, column) {
      const date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(parseInt(date + "000")).format("YYYY-MM-DD")
    },
    // 触发搜索按钮
    handleSearch() {
      this.query.page = 1
      this.getData()
    },
    // 搜索套餐
    getData() {
      getMealList(this.query).then(res => {
        this.tableData = res.data
        if (this.query.page === 1) {
          this.pageTotal = res.count
        }
      })
    },
    save(row) {
      saveMeal(row.id, row).then(res => {
        if (res) {
          this.$message.success('保存成功')
        }
        this.getData()
      })
    },

    // 删除操作
    handleDelete(id) {
      // 二次确认删除
      this.$confirm("确定要删除吗？", "删除提示", {
        type: "warning"
      }).then(() => {
        deleteMeal(id).then(res => {
          if (res) {
            this.$message.success('删除成功')
          }
          this.getData()
        })
      }).catch(() => {
      });
    },

    // 分页导航
    handlePageChange(val) {
      this.query.page = val
      this.getData()
    },

    // eslint-disable-next-line no-unused-vars
    release(content) {
    },

    getAllFranchisee() {
      getFranchisee().then(res => {
        res.push({ value: 0, label: '平台' })
        this.franchiseeOptions = res
      })
    },

    tinymcechange(content) {
      this.form.memo = content
    },

    handleEdit(index, row) {
      this.idx = index;
      getMealDetail(row.id).then(res => {
        this.actTitle = "编辑"
        this.form = res
        this.form.price = parseFloat(res.price / 100).toFixed(2)
        this.form.cost = parseFloat(res.cost / 100).toFixed(2)
        this.editVisible = true
        this.getAllFranchisee()
      })
      this.getDayTime()
      this.openTime = row.openTime
      this.getOpenTime()
    },

    // 添加操作
    handleAdd() {
      this.form = {}
      this.form.id = 0
      this.form.company_id = 0
      this.editVisible = true
      this.getAllFranchisee()
    },

    saveEdit() {
      this.editVisible = false
      this.form.price = parseInt(this.form.price * 100)
      this.form.cost = parseInt(this.form.cost * 100)
      this.editStoreOpenTime()
      this.form.openTime = JSON.stringify(this.timeObj)
      // eslint-disable-next-line no-unused-vars
      saveMeal(this.form.id, this.form).then(res => {
        this.$message.success("保存成功")
        this.getData()
      })
    },


    setIsvalidate(index, id, isvalidate) {
      setMealIsvalidate(id, isvalidate).then(res => {
        if (res === true) {
          this.$message.success('保存成功')
          this.tableData[index].is_validate = isvalidate
        }
      })
    },

    // eslint-disable-next-line no-unused-vars
    handleAvatarSuccess(res, file) {
      this.form.cover = res.url
    },
    // eslint-disable-next-line no-unused-vars
    handleListSuccess(res, file) {
      this.form.image_list.push(res.url)
    },

    //   展示详情
    showDetail(id) {
      getMealDetail(id).then(res => {
        this.detailData = res
      })
      this.detailVisible = true
    },
    getDayTime() {
      this.timeList = []
      for (let i = 0; i < 24; i++) {
        let itemTime = {}, itemTime2 = {}
        itemTime.time1 = (i < 10) ? ('0' + i + ':00') : (i + ':00')
        itemTime2.time1 = (i < 10) ? ('0' + (i + ':30')) : (i + ':30')
        this.timeList.push(itemTime)
        this.timeList.push(itemTime2)
      }
      this.timeList.forEach(item => {
        item.is_select = false
      })
      this.weekList.forEach(item => {
        item.timeList = JSON.parse(JSON.stringify(this.timeList))
      })
    },
    getOpenTime() {
      let openTime = JSON.parse(this.openTime)
      // 将得到的数据处理成想要的结构
      this.weekList.forEach(item => {
        if (JSON.stringify(openTime) != "{}") {
          for (let key in openTime) {
            if (key == item.value) {
              item.obj = openTime[key]
              item.timeList.forEach((time, index) => {
                for (let time_key in item.obj) {
                  if (time_key == index) {
                    time.is_select = item.obj[time_key]
                  }
                }
              })
            }
          }
        } else {
          item.timeList.forEach(time => {
            time.is_select = false
          })
        }
      })
    },

    // 选择
    changeAtive(index, time_index) {
      this.weekList[index].timeList[time_index].is_select = !this.weekList[index].timeList[time_index].is_select
    },

    // 全选
    handleAllSelect(index) {
      this.weekList[index].timeList.forEach(item => {
        item.is_select = true
      })
    },

    // 清空
    cancelAllSelect(index) {
      this.weekList[index].timeList.forEach(item => {
        item.is_select = false
      })
    },

    // 重置
    onReSet(index) {
      let openTime = JSON.parse(this.openTime)
      let reWeekList = openTime[index + 1]
      this.weekList[index].timeList.forEach((item, time_index) => {
        for (let key in reWeekList) {
          if (key == time_index) {
            item.is_select = reWeekList[key]
          }
        }
      })
    },

    // 保存门店营业时间
    editStoreOpenTime() {
      // 将目前的数据处理成想要的数据，从内到外处理
      this.weekList.forEach(item => {
        item.obj = {}
        item.timeList.forEach((time, index) => {
          item.obj[index] = time.is_select
        })
      })
      let obj = {}
      this.weekList.forEach(item => {
        obj[item.value] = item.obj
      })
      this.timeObj = obj
    },

    getCompanyMap(){
      getCompanyList({page:1,page_size:9999,type:1}).then(res => {
        let companyData = res.data
        this.companyData = companyData
        companyData.forEach(item => {
          this.companyMap.set(item.id, item.name)
        })
      })
    }
  }
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 200px;
  display: inline-block;
}

.table {
  width: 100%;
  font-size: 14px;
}

.red {
  color: #ff0000;
}

.mr10 {
  margin-right: 10px;
}

.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.el-dialog__body {
  height: 50vh;
  overflow: auto;
}

.detail_style {
  padding-left: 5%;
  display: flex;
}

.detail_style img {
  width: 300px;
  margin-right: 20px;
  flex: 1;
}

.row_style {
  flex: 1;
}

.el-form-item__label {
  width: 50px;
}

.el-row {
  margin-bottom: 20px;
}

.el-col {
  border-radius: 4px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.fw900 {
  font-weight: 900;
}

.qf {
  margin-left: 10px;
  display: inline-block;
  border: 1px solid #DCDFE6;
  padding: 0 10px;
  box-sizing: border-box;
  border-radius: 5px;
  color: #606266;
  box-shadow: 0px 0px 3px 0px #eee;
}

.ml10 {
  margin-left: 5px;
}

.demo-collapse {
  margin: 0 auto;
  width: 90%;
  margin-top: 30px;
  display: flex;
  justify-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.el-collapse {
  width: 90%;
}

.time_box {
  display: flex;
  flex-wrap: wrap;
}

.time_item {
  width: 100px;
  border: 1px solid #b7b6b6;
  text-align: center;
  padding: 5px 0px;
  margin: 5px 10px;
  font-size: 15px;
  border-radius: 10px;
  box-shadow: 0px 0px 5px 0px #e3e2e2;
  color: gray;
}

.time_active {
  width: 100px;
  background: #69aae7;
  color: white;
  text-align: center;
  padding: 5px 0px;
  margin: 5px 10px;
  border-radius: 10px;
  border: 1px solid #69aae7;
  box-shadow: 0px 0px 5px 0px #c0c0c0;
  font-size: 15px;
}

.other-footer {
  float: right;
  margin-right: 15%;
  margin-top: 30px;
}

.btn_style {
  float: right;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-right: 50px;
}
</style>
